<template>
  <svg
    width="12px"
    height="15px"
    viewBox="0 0 12 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>password</title>
    <desc>Created with Sketch.</desc>
    <g
      id="页面-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="CUSTOMER-CENTER"
        transform="translate(-805.000000, -576.000000)"
        fill="#CCCCCC"
      >
        <g id="编组-19" transform="translate(710.000000, 303.000000)">
          <path
            d="M97.2691972,278.631703 L97.2691972,277.275675 C97.2691972,275.19266 98.9609048,273.5 101.052875,273.5 C103.144845,273.5 104.836553,275.19266 104.836553,277.275675 L104.836553,278.631703 L105.907498,278.631703 C106.516223,278.631703 107,279.125244 107,279.722712 L107,286.408992 C107,287.006459 106.516223,287.5 105.907498,287.5 L96.0925024,287.5 C95.4837773,287.5 95,287.006459 95,286.408992 L95,279.722712 C95,279.125244 95.4837773,278.631703 96.0925024,278.631703 L97.2691972,278.631703 Z M96.3670886,279.979297 L96.3670886,286.152406 L105.632911,286.152406 L105.632911,279.979297 L96.3670886,279.979297 Z M103.469464,278.61094 L103.469464,277.275675 C103.469464,275.93245 102.385218,274.847594 101.052875,274.847594 C99.7205321,274.847594 98.6362858,275.93245 98.6362858,277.275675 L98.6362858,278.61094 L103.469464,278.61094 Z"
            id="password"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LockSvg'
});
</script>
